/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Button_ApplyingInputs */

const en_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applying...`)
};

const de_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird angewendet...`)
};

const fr_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application...`)
};

const es_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicando...`)
};

const it_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicazione...`)
};

const nl_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toepassen...`)
};

const pl_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stosowanie...`)
};

const fi_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovelletaan...`)
};

const da_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anvender...`)
};

const sv_keyword_optimizer_button_applying = /** @type {(inputs: Keyword_Optimizer_Button_ApplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillämpar...`)
};

/**
* | output |
* | --- |
* | "Applying..." |
*
* @param {Keyword_Optimizer_Button_ApplyingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_button_applying = /** @type {((inputs?: Keyword_Optimizer_Button_ApplyingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Button_ApplyingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_button_applying(inputs)
	if (locale === "fr") return fr_keyword_optimizer_button_applying(inputs)
	if (locale === "es") return es_keyword_optimizer_button_applying(inputs)
	if (locale === "it") return it_keyword_optimizer_button_applying(inputs)
	if (locale === "nl") return nl_keyword_optimizer_button_applying(inputs)
	if (locale === "pl") return pl_keyword_optimizer_button_applying(inputs)
	if (locale === "fi") return fi_keyword_optimizer_button_applying(inputs)
	if (locale === "da") return da_keyword_optimizer_button_applying(inputs)
	if (locale === "sv") return sv_keyword_optimizer_button_applying(inputs)
	return en_keyword_optimizer_button_applying(inputs)
});